import { parse } from 'hub-http/helpers/params';
export const parseQueryFromLocation = location => {
  if (!location.search || !location.search.length) {
    return {};
  }
  return parse(location.search.substring(1));
};